import { getCommon } from 'app-lib/assetUtils'
import { ReactComponent as OokiWorker } from 'bzx-common/src/assets/images/ooki-worker.svg'
import { chainConfigs } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { Icon } from 'ui-framework'
import ToolsVM from './ToolsVM'
import WrapNative from './WrapNative'

export function Tools({ vm }: { vm: ToolsVM }) {
  const { chainId } = vm.rootStore.web3Connection
  if (!chainId) {
    return null
  }
  const { native } = chainConfigs[chainId]
  const { route } = vm.rootStore
  const { spriteLogo: tokenIcon } = getCommon(native.asset)

  return (
    <div className="margin-bottom-4">
      {route.endsWith('tools') && (
        <>
          <div className="txt-center margin-bottom-2">
            <OokiWorker height="175" />
            <h2 className="title-page txt-center">Ooki Tools</h2>
          </div>

          <div className="tools__grid">
            <div className="panel--simple padded-1 txt-center">
              <NavLink className="link--invisible" to="/tools/wrap-native">
                <h3 className="h3 txt-blue-aim">Native Token Wrapper</h3>
                <Icon name={tokenIcon} size={20} /> {native.asset} ↔ {native.wrapped}
              </NavLink>
            </div>
          </div>
        </>
      )}

      {route.endsWith('tools/wrap-native') && <WrapNative vm={vm} />}
    </div>
  )
}

export default observer(Tools)
